import { ArrowLeftIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ExpiryDashboard } from '@/components/features/supplier-certificates/components/expiry-dashboard';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/_authenticated/certificates')({
  component: CertificatesDashboardPage,
});

function CertificatesDashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="container py-6 space-y-6">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Certificate Expiry Dashboard</h1>
          <p className="text-muted-foreground mt-1">
            Monitor all supplier certificate expirations in one place
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" onClick={() => navigate({ to: '/supplier-certificates' })}>
            <HugeiconsIcon icon={ArrowLeftIcon} className="mr-2 h-4 w-4" />
            Manage Certificates
          </Button>
        </div>
      </div>

      <ExpiryDashboard />
    </div>
  );
}
